export default __webpack_public_path__ + "locales/si/SocialAuthWelcomeDialog.json?hash=9da3c251b9533a76483335ca9b3d6d7a";